import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';

import PageLayout from '../_partials/PageLayout';
import { Spin } from "antd";
import './style.scss';
import { fetchBanners } from "../../../actions/mine_craft/bannersActions";
import List from "../../mine_craft/Banners/_partials/_List";
import PageHeader from "src/componets/PageHeader";
import Wrapper from "../../../componets/Wrapper";
import NavBarThree from "../../../componets/NavBarThree";
import Can from "../../../componets/Can";
import { InboxOutlined, SettingOutlined } from "@ant-design/icons";
import { selectBannerIds, setNewGroupParams, setReorderIds } from "../../../store/mine_craft/bannersSlice";
import Dropzone from "../../mine_craft/Banners/Dropzone";
import minecraftUrls from "../../../configs/mine_craft/minecraftUrls";
import { queryParams } from "../../../helpers/UrlHelpers";
import { useSearchParams } from "react-router-dom";
import Filter, { FilterInterface } from "../../../componets/Filter";
import Settings from "./Settings";

export interface PropsInterface {
  appId: 1 | 2;
}
const LIMIT = 42;

const NAV_ITEMS: {[index: number]: any} = {
  1: {
    id: 1,
    name: 'App',
    url: minecraftUrls.bannersPath({ target: 'app' })
  },
  2: {
    id: 2,
    name: 'Users',
    url: minecraftUrls.bannersPath({ target: 'user' })
  }
};

const DEFAULT_ORDER_BY = 'order';

const Banners = ({ appId }: PropsInterface) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const status = useAppSelector(state => state.mineCraft.banners.status);
  const error = useAppSelector(state => state.mineCraft.banners.error);
  const ids = useAppSelector(selectBannerIds);
  const target = queryParams.get(searchParams,'target') || 'app';
  const currentPage = queryParams.getInt(searchParams,'page') || 1;
  const activeId = Object.values(NAV_ITEMS).find(e => e.url === minecraftUrls.bannersPath({ target: target }))?.id || 1;
  const filterProps: FilterInterface = {};

  useEffect(() => {
    const params: any = queryParams.requestParams(
      searchParams,
      {
        app_id: appId,
        limit: LIMIT,
        offset: (currentPage - 1) * LIMIT,
        target: target
      },
      ['order_by', 'order', 'date_from', 'date_to'],
      { 'order_by': DEFAULT_ORDER_BY }
    );

    dispatch(fetchBanners(params));
  }, [dispatch, appId, target, currentPage, searchParams]);

  function onClickGroupCreate() {
    const params: any = { app_id: appId };

    dispatch(setNewGroupParams(params));
  }

  function onSettings() {
    dispatch(setReorderIds({ ids }));
  }

  if (status === 'loading') {
    return <Spin/>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>
  }

  filterProps.orderBy = {
    defaultKey: DEFAULT_ORDER_BY,
    defaultSort: 'asc',
    items: [
      { name: 'Order', key: 'order' },
      { name: 'Date', key: 'id' },
    ]
  };

  function renderSettingButton() {
    return (
      <Can capability='write_minecraft'>
        <NavBarThree>
          <NavBarThree.Button onClick={onSettings}>
            <SettingOutlined /> Banners Settings
          </NavBarThree.Button>
        </NavBarThree>
      </Can>
    );
  }

  return (
    <PageLayout>
      <PageHeader
        title='Banners'
        navs={NAV_ITEMS}
        activeId={activeId}
      >
        {target === 'app' && renderSettingButton()}
      </PageHeader>

      <Can capability='write_minecraft'>
        <Wrapper>
          <NavBarThree>
            <NavBarThree.Button className='v-link2' onClick={onClickGroupCreate}>
              <InboxOutlined /> Banners Dropzone
            </NavBarThree.Button>
          </NavBarThree>
        </Wrapper>
      </Can>

      <div className='v-container'>
        <Wrapper type='type-1' border className='v-mb-10'>
          <Filter
            dateRange
            {...filterProps}
          />
        </Wrapper>

        <List limit={LIMIT} pagination={true} />
      </div>

      <Dropzone />
      <Settings />
    </PageLayout>
  );
}

export default Banners;
